import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../helpers";

export interface RecordingTranscriptConfig {
  transcriptionEnabled: boolean;
}

export interface RecordingTranscriptSummaryConfig {
  isSummaryEnabled: boolean;
}

export interface RecordingSettings {
  featureAvailable: boolean;
  disableAgentControl: boolean;
  discardRecording: boolean;
}

export type TranscriptSummaryFailureReason = "None" | "FeatureNotEnabled" | "RecordingInfoNotAvailable" | "TranscriptionLanguageNotSupported" | "TranscriptionFailed" | "TranscriptionNotAvailable" | "TranscriptionDisabled";

export interface RecordingTranscriptSummary {
  summary: string | null;
  failureReason: TranscriptSummaryFailureReason;
}

const recordingManagerApi = createApi({
  reducerPath: "recordingManager",
  tagTypes: [],
  baseQuery: apiBaseQuery("/recording"),
  endpoints: builder => ({
    getRecordingSettings: builder.query<RecordingSettings, { conversationId: string; businessUnitId: string | null }>({
      query: ({ conversationId, businessUnitId }) => `/conversations/${conversationId}?businessUnitId=${businessUnitId ?? ""}`,
    }),
    getRecordingTranscriptConfig: builder.query<RecordingTranscriptConfig, void>({
      query: () => "/transcript/enabled",
    }),
    getRecordingTranscriptSummaryConfig: builder.query<RecordingTranscriptSummaryConfig, void>({
      query: () => "/transcript/summary/enabled",
    }),
    getRecordingTranscriptSummary: builder.query<RecordingTranscriptSummary, { conversationId: string; workItemId: string }>({
      query: ({ conversationId, workItemId }) => `transcript/summary?conversationId=${conversationId}&workItemId=${workItemId}`,
    }),
  }),
});

export const {
  useGetRecordingSettingsQuery,
  useGetRecordingTranscriptConfigQuery,
  useGetRecordingTranscriptSummaryConfigQuery,
  useLazyGetRecordingTranscriptSummaryQuery,
} = recordingManagerApi;

export default recordingManagerApi;
